export enum AUDIENCE_TYPE {
  NONE = '',
  SEGMENT = 'segment',
  CSV = 'csv',
  CSV_DYNAMIC = 'csv_dynamic',
  EXTERNAL = 'external',
  ADOBE = 'adobe',
  FTP = 'ftp',
  HTTPS = 'https',
  S3 = 's3',
  PERFORMANCE_REPORT = 'performance_report',
  EVENT_DETAIL = 'event_detail',
  SALES = 'sales',
}

export enum AUDIENCE_STATUS {
  NEW = 'new',
  IN_PROGRESS = 'in progress',
  READY = 'ready',
  SYNC = 'sync',
  ERROR = 'error',
  INACTIVE = 'inactive',
}

export enum AUDIENCE_CSV_ID_TYPE {
  CUSTOMER_ID = 'customerId',
  EMMA_ID = 'emmaId',
  DEVICE_ID = 'deviceId',
}
